import React, { memo } from "react";
import * as Styles from "./number-input-group.styles";
import { NumberInput } from "../number-input";
import { Label } from "../label";
import { Spacer } from "../../spacer";
import { ErrorMessage } from "../error";

export const NumberInputGroup = memo(
  ({ id, label, required, value, onChange, error }) => {
    return (
      <Styles.Wrapper>
        <Label>
          {label} {required && "(required)"}
        </Label>
        <Spacer height={1} />
        <NumberInput
          name={id}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        {error && <ErrorMessage>{error}</ErrorMessage>}
      </Styles.Wrapper>
    );
  }
);
